import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Modal } from '../common/Modal';

interface EditImageModalProps {
	title: string;
	src?: string;
	scrSet?: string;
	image?: string;
	isOpen: boolean;
	customButonTextId?: string;
	onClose: () => void;
	onSelect: () => void;
	onDelete?: () => void;
}

export const EditImageModal = (props: EditImageModalProps) => {
	return (
		<Modal
			isOpen={props.isOpen}
			closeOnBackdropClick={true}
			onClose={props.onClose}
			className="select-image-modal"
			header={
				<h2 className="edit-image-modal-title">
					<FormattedMessage id={props.title} />
				</h2>
			}
		>
			<>
				{props.src && !props.image && <Image srcSet={props.scrSet} src={props.src} />}
				{props.image && <Image className="edit-image-modal-photo" src={props.image} />}
				<ButtonContainer className="edit-image-modal-buttons">
					<button
						className="button-replace-photo"
						onClick={(e) => {
							e.stopPropagation();
							props.onSelect();
						}}
					>
						<FormattedMessage id={props.customButonTextId ?? 'button.changeImage'} />
					</button>
					{props.onDelete && (
						<button
							className="button-secondary"
							onClick={(e) => {
								e.stopPropagation();
								props.onDelete?.();
							}}
						>
							<FormattedMessage id="button.deleteImage" />
						</button>
					)}
				</ButtonContainer>
			</>
		</Modal>
	);
};

const Image = styled.img`
	display: block;
	padding-bottom: 2rem;
	width: 100%;
	border-radius: 3px;
`;

const ButtonContainer = styled.p`
	display: grid;
	justify-content: center;
	grid-row-gap: 1rem;
`;
